module.exports = __webpack_public_path__ + "static/media/GalleryImage06.333cac37.jpg";